export class AppDatePicker extends HTMLElement {
  static get observedAttributes() {
    return ["label", "value", "disabled", "required", "error", "helper", "min", "max"];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  get value(): string {
    const input = this.querySelector("input");
    return input ? input.value : "";
  }

  set value(val: string) {
    const input = this.querySelector("input");
    if (input) {
      input.value = val;
    }
  }

  private render() {
    const label = this.getAttribute("label") || "";
    const value = this.getAttribute("value") || "";
    const min = this.getAttribute("min") || "";
    const max = this.getAttribute("max") || "";
    const disabled = this.hasAttribute("disabled");
    const required = this.hasAttribute("required");
    const error = this.getAttribute("error") || "";
    const helper = this.getAttribute("helper") || "";

    const id = `date-${Math.random().toString(36).substring(2, 9)}`;

    this.innerHTML = `
      <div class="form-group">
        ${label ? `<label for="${id}" class="form-label ${required ? "required" : ""}">${label}</label>` : ""}
        <input
          id="${id}"
          type="date"
          class="form-input ${error ? "error" : ""}"
          value="${value}"
          ${min ? `min="${min}"` : ""}
          ${max ? `max="${max}"` : ""}
          ${disabled ? "disabled" : ""}
          ${required ? "required" : ""}
        />
        ${error ? `<span class="form-error">${error}</span>` : ""}
        ${helper && !error ? `<span class="form-helper">${helper}</span>` : ""}
      </div>
    `;
  }
}

if (!customElements.get("app-date-picker")) {
  if (!customElements.get("app-date-picker")) {
    customElements.define("app-date-picker", AppDatePicker);
  }
}

export class AppDateRange extends HTMLElement {
  static get observedAttributes() {
    return ["label", "start-value", "end-value", "disabled", "required"];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  private render() {
    const label = this.getAttribute("label") || "Período";
    const startValue = this.getAttribute("start-value") || "";
    const endValue = this.getAttribute("end-value") || "";
    const disabled = this.hasAttribute("disabled");
    const required = this.hasAttribute("required");

    this.innerHTML = `
      <div class="form-group">
        <span class="form-label ${required ? "required" : ""}">${label}</span>
        <div style="display: flex; align-items: center; gap: 8px;">
          <input type="date" class="form-input" value="${startValue}" ${disabled ? "disabled" : ""} style="flex: 1;" />
          <span style="color: var(--color-text-muted); font-size: 0.8125rem;">até</span>
          <input type="date" class="form-input" value="${endValue}" ${disabled ? "disabled" : ""} style="flex: 1;" />
        </div>
      </div>
    `;
  }
}

if (!customElements.get("app-date-range")) {
  if (!customElements.get("app-date-range")) {
    customElements.define("app-date-range", AppDateRange);
  }
}
